module.exports = __webpack_public_path__ + "57a76ee98b50de2cb90db135892caabd.svg";